// 公共接口
import request from '@/util/http.js'
//项目列表
export const getDepList = () => {
  return request({
    url: '/common/getDepList',
    method: 'get',
  })
}
// 面试登记
export const interviewRegistration = (data) => {
  return request({
    url: '/getApi/interviewRegistration',
    method: 'post',
    data: data
  })
}
// 更新选择项目id
export const getSelectDepId = (data) => {
  return request({
    url: '/common/getSelectDepId',
    method: 'post',
    data: data
  })
}